import React from "react";

export const FormGroup = (props: { children: React.ReactNode; header: string }) => (
  <div className="my-content">
    <h4>{props.header}</h4>
    {props.children}
  </div>
);
